/**
 * Custom Measurements — single-submit inquiry (email + WhatsApp)
 * -----------------------------------------------------------------------
 * Triggered by the "Customize Your Size" value in the product's Size
 * option: selecting it reveals the measurement panel, selecting any
 * normal size hides it again.
 *
 * This script does NOT touch Add to Cart, Buy Now, or the sticky cart —
 * they are left exactly as the theme renders them. (Earlier versions
 * hid them; that caused normal sizes to lose their buttons, so all
 * hiding was removed by request.)
 *
 * On submit, one click does two things:
 *   1. POSTs to Shopify's native contact form (/contact) — emails the
 *      store's configured customer email server-side. Real send; the
 *      customer's own email app is never involved.
 *   2. Opens WhatsApp pre-filled with the same details.
 *
 * LIMITATION: wa.me can only OPEN a pre-filled chat — a browser cannot
 * send WhatsApp for the customer. Automatic delivery needs the WhatsApp
 * Business API (KwikEngage). The email leg is the reliable one.
 *
 * No Shopify cart or order is created by this script.
 */
(function () {
  "use strict";

  var WHATSAPP_NUMBER = "919818600678"; // +91 98186 00678
  var CUSTOM_PREFIX = "Customize"; // matches "Customize Your Size"

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    var panel = document.querySelector("[data-cm-inline]");
    if (!panel || panel.dataset.cmInitialized) return;
    panel.dataset.cmInitialized = "1";

    var heroForm = document.querySelector("form.adhive-atc-form");
    var ctaStack = heroForm ? heroForm.querySelector(".cta-stack") : null;
    var sizesGroup = document.querySelector(".adhv-wrap .sizes");

    // Position the panel just above the buy buttons (does not modify them).
    if (heroForm) {
      if (ctaStack && ctaStack.parentNode === heroForm) {
        heroForm.insertBefore(panel, ctaStack);
      } else {
        heroForm.appendChild(panel);
      }
    }

    var requiredInputs = panel.querySelectorAll("[data-cm-required]");
    var errorEl = panel.querySelector("[data-cm-error]");
    var successEl = panel.querySelector("[data-cm-success]");
    var submitBtn = panel.querySelector("[data-cm-submit]");
    var productTitle = panel.dataset.productTitle || "Product";
    var productUrl = panel.dataset.productUrl || "";

    function setEnabled(enabled) {
      document.body.classList.toggle("cm-custom-active", enabled);   // <-- add this line
      panel.hidden = !enabled;
      panel.querySelectorAll("input, textarea, button").forEach(function (el) {
        el.disabled = !enabled;
      });
      errorEl.hidden = true;
      successEl.hidden = true;
    }

    function isCustomValue(value) {
      return (value || "").indexOf(CUSTOM_PREFIX) === 0;
    }

    if (sizesGroup) {
      sizesGroup.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-value]");
        if (!btn) return;
        setEnabled(isCustomValue(btn.getAttribute("data-value")));
      });

      var active = sizesGroup.querySelector("[data-value].active");
      setEnabled(!!(active && isCustomValue(active.getAttribute("data-value"))));
    } else {
      setEnabled(false);
    }

    function fieldValue(idPrefix) {
      var el = panel.querySelector("[id^='" + idPrefix + "-']");
      return el ? el.value.trim() : "";
    }

    function validate() {
      errorEl.hidden = true;
      var missing = Array.prototype.filter.call(requiredInputs, function (el) {
        return el.value.trim() === "";
      });
      if (missing.length) {
        errorEl.textContent =
          "Please fill in all required fields marked with * to continue.";
        errorEl.hidden = false;
        missing[0].focus();
        return false;
      }
      var email = fieldValue("cmEmail");
      if (email.indexOf("@") === -1 || email.indexOf(".") === -1) {
        errorEl.textContent = "Please enter a valid email address.";
        errorEl.hidden = false;
        return false;
      }
      return true;
    }

    function buildMessage() {
      var lines = [];
      lines.push("CUSTOM SIZE REQUEST");
      lines.push(productTitle);
      if (productUrl) lines.push(productUrl);
      lines.push("");
      lines.push("Bust: " + fieldValue("cmBust") + " in");
      lines.push("Waist: " + fieldValue("cmWaist") + " in");
      lines.push("Hips: " + fieldValue("cmHips") + " in");
      var shoulder = fieldValue("cmShoulder");
      var length = fieldValue("cmLength");
      var sleeve = fieldValue("cmSleeve");
      if (shoulder) lines.push("Shoulder: " + shoulder + " in");
      if (length) lines.push("Full Length: " + length + " in");
      if (sleeve) lines.push("Sleeve Length: " + sleeve + " in");
      var notes = fieldValue("cmNotes");
      if (notes) {
        lines.push("");
        lines.push("Notes: " + notes);
      }
      lines.push("");
      lines.push("Name: " + fieldValue("cmName"));
      lines.push("WhatsApp: " + fieldValue("cmPhone"));
      lines.push("Email: " + fieldValue("cmEmail"));
      return lines.join("\n");
    }

    function sendEmail(message) {
      var params = new URLSearchParams();
      params.append("form_type", "contact");
      params.append("utf8", "\u2713");
      params.append("contact[name]", fieldValue("cmName"));
      params.append("contact[email]", fieldValue("cmEmail"));
      params.append("contact[phone]", fieldValue("cmPhone"));
      params.append("contact[body]", message);
      return fetch("/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "text/html",
        },
        body: params.toString(),
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener("click", function () {
        if (!validate()) return;

        var message = buildMessage();
        var originalLabel = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = "Sending\u2026";

        // Open WhatsApp synchronously inside the click handler — opening
        // it later (in a .then) gets blocked as a popup.
        var waWindow = window.open(
          "https://wa.me/" +
            WHATSAPP_NUMBER +
            "?text=" +
            encodeURIComponent(message),
          "_blank"
        );

        sendEmail(message)
          .then(function () {
            successEl.textContent = waWindow
              ? "Sent! Our team has your measurements by email. WhatsApp has also opened with your details \u2014 tap send there so we can reply to you faster."
              : "Sent! Our team has your measurements by email and will get back to you shortly.";
            successEl.hidden = false;
            submitBtn.textContent = "Measurements Sent \u2713";
          })
          .catch(function () {
            errorEl.textContent =
              "We couldn't send the email automatically. Please use the WhatsApp window that just opened, or write to help@prettypixie.com.";
            errorEl.hidden = false;
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          });
      });
    }
  }
})();
